import {PROCESSING, WSError} from "@pledger/frontend-commons";
import {UserProfile} from "./dto/UserProfile";


export const accountWServiceActions = {
    GET_USER_PROFILE_ACTION : { type : 'accountWServiceActions.GET_USER_PROFILE_ACTION', build : () => {  return { type: accountWServiceActions.GET_USER_PROFILE_ACTION.type, meta: { request: { status: PROCESSING  } } } }},
    GET_USER_PROFILE_SUCCEEDED_ACTION : { type : 'accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION', build : (data : UserProfile) => {return {type: accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION.type,payload: data}}},
    GET_USER_PROFILE_FAILED_ACTION : { type : 'accountWServiceActions.GET_USER_PROFILE_FAILED_ACTION', build : (error : WSError) => {return {type: accountWServiceActions.GET_USER_PROFILE_FAILED_ACTION.type, payload:  error}}},




}
